export default class AboutController {
  static $inject = ['$scope'];

  constructor($scope:ng.IScope) {

  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/about/about.controller.ts
 **/